<!-- Search Box -->
<div class="searchBox">
    <div class="searchBoxContainer">
        <a href="javascript:void(0);" class="closeBtn">
            <svg viewBox="0 0 413.348 413.348" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z">
                </path>
            </svg>
        </a>
        <div class="search-bar-inner">
            <input type="text" placeholder="Enter Your keywords" />
            <button type="submit">
                <img src="../assets/images/all-instructor/search.svg" alt="icon">
            </button>
        </div>
    </div>
</div>
<!-- Search Box -->
<!-- Header Start -->
<header class="el-header-wrapper">
    <div class="container">
        <!-- <div class="el-header-parent">
            <div class="el-logo">
                <a href="index.html"><img src="../assets/images/all-instructor/logo.svg" alt="Logo"></a>
            </div>
            <div class="el-header-right ">
                <div class="el-nav-menu">
                    <ul>
                        <li><a href="index.html">home</a></li>
                        <li><a href="about.html">about us </a></li>
                        <li class="active el-has-menu"><a href="javascript:;">blogs <svg version="1.1" x="0" y="0"
                                    viewBox="0 0 491.996 491.996" style="enable-background:new 0 0 512 512">
                                    <g>
                                        <path
                                            d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                            opacity="1"></path>
                                    </g>
                                </svg></a>
                            <ul class="el-sub-menu">
                                <li><a href="blog-single.html">blog single</a></li>
                                <li><a href="blog-medium.html">blog medium</a></li>
                            </ul>
                        </li>


                        <li><a href="contact.html">contact us</a></li>
                    </ul>
                </div>

                <div class="el_toggle_btn">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div> -->
        <div class="el-header-parent">
            <div class="el-logo">
                <a [routerLink]="['/']"><img src="../assets/images/all-instructor/sm-logo.png" alt="Logo"></a>
            </div>
            <div class="el-header-right">
                <div class="el-nav-menu">
                    <ul>

                        <ng-container *ngIf="PREP_UserInfo==null">
                            <li><a [routerLink]="['/']" [routerLinkActive]="['active']">home</a></li>
                            <li><a [routerLink]="['/product']" [routerLinkActive]="['active']">Products</a></li>
                            <li><a [routerLink]="['/faq']" [routerLinkActive]="['active']">FAQ</a></li>
                            <li><a [routerLink]="['/contact']" [routerLinkActive]="['active']">contact us</a></li>
                            <!-- <li><a *ngIf="PREP_UserInfo==null" [routerLink]="['/login']" class="theme-color">Sign In <i
                                        class="fa fa-sign-in  theme-color"></i></a>
                            </li> -->
                            <li *ngIf="cartItemCount > 0"><a [routerLink]="['/cart']" class="theme-color">
                                    <!-- <i class="fa fa-shopping-cart  theme-color"></i> -->
                                    <img src="../assets/images/all-instructor/cart-ic.gif" alt="cart">
                                    <span class="cart-badge theme-color cart-bounce">{{cartItemCount}}</span></a></li>

                        </ng-container>


                    </ul>


                </div>


                <div class="el_toggle_btn">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>


            </div>
            <div class="el-header-right" *ngIf="PREP_UserInfo!=null">
                <div class="el-nav-menu">
                    <ul>
                        <li><a [routerLink]="['/dashboard']" [routerLinkActive]="['active']">DashBoard</a></li>
                        <li><a [routerLink]="['/my-study']" [routerLinkActive]="['active']">My Study</a></li>
                        <li><a [routerLink]="['/report']" [routerLinkActive]="['active']">My Progress</a></li>
                        <li class=" el-has-menu"><a href="javascript:;">Products <svg version="1.1" x="0" y="0"
                                    viewBox="0 0 491.996 491.996" style="enable-background:new 0 0 512 512"
                                    href="javascript:void(0);">
                                    <g>
                                        <path
                                            d="m484.132 124.986-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86-7.208 0-13.964 2.792-19.036 7.86l-183.84 183.848L62.056 108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968 2.788-19.036 7.856l-16.12 16.128c-10.496 10.488-10.496 27.572 0 38.06l219.136 219.924c5.064 5.064 11.812 8.632 19.084 8.632h.084c7.212 0 13.96-3.572 19.024-8.632l218.932-219.328c5.072-5.064 7.856-12.016 7.864-19.224 0-7.212-2.792-14.068-7.864-19.128z"
                                            opacity="1"></path>
                                    </g>
                                </svg></a>
                            <ul class="el-sub-menu">
                                <li><a [routerLink]="['/MyPlan']">My Plan</a></li>
                                <li><a [routerLink]="['/buy-products']">Buy Products
                                    </a></li>
                                <li><a href="https://www.silverzone.org/books" target="_blank">Buy Books
                                    </a></li>
                            </ul>
                        </li>

                        <li *ngIf="cartItemCount > 0"><a [routerLink]="['/cart']" class="theme-color">
                                <!-- <i
                                    class="fa fa-shopping-cart  theme-color"></i> -->

                                <img src="../assets/images/all-instructor/cart-ic.gif" alt="cart"
                                    class="color-contrast ">
                                <span class="cart-badge theme-color cart-bounce">{{cartItemCount}}</span></a></li>





                    </ul>


                </div>


            </div>
            <div class="el-header-search">


                <div class="el-nav-menu1 ">
                    <ul>
                        <a *ngIf="PREP_UserInfo==null" [routerLink]="['/login']" class="el-btn signin_el_btn">Sign
                            In</a>
                        <li class="active el-has-menu1" *ngIf="PREP_UserInfo!=null">
                            <a class="p-0 profile-img">
                                <img src="{{PREP_UserInfo?.profilePic}}" alt="user icon" class="me-0"
                                    style="border-radius: 50%;right: 0px;">
                            </a>


                            <ul class="el-sub-menu1">
                                <li>
                                    <span
                                        style="display: flex; align-items: center; gap: 5px; text-transform: capitalize;">
                                        <i class="fas fa-user"></i> {{PREP_UserInfo.userName}} <a
                                            [routerLink]="['/update-user']"><i class="fas fa-edit"></i></a></span>


                                </li>
                                <hr>
                                <li *ngIf="PREP_UserInfo.className!=null" style="text-transform: capitalize;">
                                    <i class="fas fa-child"></i>

                                    {{PREP_UserInfo?.childName}}: <span *ngIf="PREP_UserInfo.classId <= '12'">Class
                                        {{PREP_UserInfo.classId}}</span> <span
                                        *ngIf="PREP_UserInfo.classId > '12'">Class {{PREP_UserInfo.className}}</span>

                                </li>
                                <hr *ngIf="PREP_UserInfo.className!=null">
                                <li (click)="Switch_Child()"><a><i class="fas fa-child"></i>Add/Switch Child</a></li>

                                <hr>
                                <!-- <li><a><i class="fas fa-box-open"></i> Change Password</a></li>
                                <hr> -->
                                <li><a [routerLink]="['/myOrder']"><i class="fas fa-box-open"></i> My Order</a></li>
                                <hr>


                                <li (click)="Logout()">

                                    <a class="signin_el_btn" style="background: transparent;"><i
                                            class="fas fa-sign-out-alt"></i>Logout</a>
                                </li>
                            </ul>
                        </li>

                    </ul>

                </div>

            </div>
        </div>
    </div>

</header>

<!-- Header End -->
<div class="modal fade" id="profileModal" tabindex="-1" aria-labelledby="profileModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content p-3">
            <div class="modal-header ">
                <h5 class="modal-title" id="profileModalLabel">My Profile</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body p-0">

                <div class="el-work-box el-work-box-1">
                    <div class="el-work-box-inner p-0">
                        <div class="el-work-img">
                            <img src="{{PREP_UserInfo?.profilePic}}" alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>{{ PREP_UserInfo?.userName || 'N/A' }}</h4>
                            <!-- <p class="el-para">Developer </p> -->
                        </div>
                        <div class="el-lesson-parent">
                            <ul>
                                <li><a class="text-white"
                                        href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Name</a>
                                    <span class="text-white">{{ PREP_UserInfo?.userName || 'N/A' }}</span>
                                    <!-- <span class="text-white"><i class="fas fa-pen"></i></span> -->
                                </li>
                                <li><a
                                        href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Email
                                    </a> <span>{{ PREP_UserInfo?.emailId || 'N/A' }}</span></li>
                                <li><a
                                        href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Mobile</a>
                                    <span>{{ PREP_UserInfo?.mobile || 'N/A' }}</span>
                                </li>
                                <li><a
                                        href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Gander</a>
                                    <span>{{ PREP_UserInfo?.genderType || 'N/A' }}</span>
                                </li>
                                <li><a
                                        href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">City</a>
                                    <span>{{ PREP_UserInfo?.city || 'N/A' }}</span>
                                </li>
                                <li><a
                                        href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">State</a>
                                    <span>{{ PREP_UserInfo?.state || 'N/A' }}</span>
                                </li>
                                <li><a
                                        href="https://kamleshyadav.com/html/educo/educo/all-instructor/course-lesson.html">Country</a>
                                    <span>{{ PREP_UserInfo?.country || 'N/A' }}</span>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>

            </div>

            <div class="modal-footer py-3">
                <button type="button" class="el-btn" data-bs-dismiss="modal">
                    Close</button>
                <button type="button" class="el-btn"><i class="fas fa-pen pe-2"> </i>
                    Edit</button>
                <button class="btn btn-primary" (click)="editProfile()">Edit Profile</button>
            </div>
        </div>
    </div>
</div>